// 📅 DATES THAT CONTRADICT EACH OTHER (owner 2026-09-13: "I can select irrational dates and it
// don't give warning" — a binder whose main agreement was due 11.11.2028 on a tenancy running
// 13.09.2026 to 12.09.2027).
//
// Every date box on these forms is a date picker, so nothing catches a wrong one on its own: any
// day of any year is a valid day. What is wrong is the RELATIONSHIP — a tenancy that ends before
// it starts, a deadline for signing the lease that falls after the tenant has already moved in.
// Those are the only ones stated here, and it matters that they are:
//
// ⚠️ ONLY CONTRADICTIONS, never "unusual". A lease signed after the tenant moved in is ordinary
//    here; so is a binder agreed the same day; so is a one-day tenancy. A rule that fires on
//    surprising-but-legal dates trains an agent to click past the one that matters, and this form
//    already refuses to save on `invalid` — so a false positive is not a nag, it is a wall.
// ⚠️ SILENT WHEN A DATE IS MISSING. A half-filled form is not yet wrong, and the required-field
//    gate already says what is absent.
// ⚠️ Keyed by field, so a template that has no such pair simply has no such rule. Nothing here
//    knows which contract it is looking at.
const ISO = /^\d{4}-\d{2}-\d{2}$/
const d = v => (ISO.test(String(v || '')) ? String(v) : null)   // string compare is date compare in ISO

// [earlier, later, message key, strict]
// `strict` = the two may not be equal either.
const ORDER = [
  // NOT strict: a one-day tenancy starts and ends on the same day, and the server accepts it
  // (lib/contract_tenancy.js `end >= start`, lib/payment_calendar.js `end < start` refuses).
  ['lease_start', 'lease_end', 'date_end_before_start', false],
  ['agreement_date', 'deadline_date', 'date_deadline_before_agreement', false],
  // The binder exists to get the lease signed BEFORE the tenancy runs. A deadline after the
  // start date is not merely odd — it describes a booking for a flat the client is already in.
  ['deadline_date', 'lease_start', 'date_deadline_after_move_in', false],
  ['agreement_date', 'contingency_deadline', 'date_contingency_before_agreement', false],
]

/** Which date fields contradict another one → Map(fieldKey → message key). Both ends are named. */
export function dateProblems(values) {
  const bad = new Map()
  for (const [a, b, key, strict] of ORDER) {
    const x = d(values?.[a]), y = d(values?.[b])
    if (!x || !y) continue
    if (strict ? x >= y : x > y) { bad.set(a, key); bad.set(b, key) }
  }
  return bad
}
